import api from '@/helpers/api';

import type {
	SaveLastContactByCompanyNeedResponse,
	SaveLastContactPayload,
	SaveLastContactResponse,
} from '@/components/modal/Profile/lastContact/types';

const saveLastContactByProfile = async (
	payload: SaveLastContactPayload
): Promise<SaveLastContactResponse> => {
	const response = await api.request({
		url: '/workers/contacts',
		method: 'POST',
		data: payload,
	});
	return response.data;
};

const saveLastContactByCompanyNeed = async (
	companyNeedId: string,
	data: SaveLastContactPayload
): Promise<SaveLastContactByCompanyNeedResponse> => {
	const response = await api.request({
		url: `/besoins/${companyNeedId}/workers/contacts`,
		method: 'POST',
		data,
	});
	return response.data;
};

export default {
	saveLastContactByProfile,
	saveLastContactByCompanyNeed,
};
